import { createAction, props } from "@ngrx/store";
import { User } from "../../models/user";
import { Role } from "../../models/rol";

//export const loadUserAct = createAction('loadUserEffect', props<{ page: number, pageSize: number}>());

export const resetUserAct = createAction('resetUserUserEffect');

//export const findAllPageableUserAct = createAction('findAllPageableUserEffect', props<{ users: User[], paginator: any }>());

export const findUserAct = createAction('findUserEffect', props<{ id: number }>());
export const loadUserByIdAct = createAction('loadUserByIdEffect', props<{ user: User }>());

export const addUserAct = createAction('addUserEffect', props<{ userNew: User }>());
export const addSuccessUserAct = createAction('addSuccessUserEffect', props<{ userNew: User }>());
export const updateUserAct = createAction('updateUserEffect', props<{ userUpdated: User }>());
export const updateSuccessUserAct = createAction('updateSuccessUserEffect', props<{ userUpdated: User }>());
//export const removeUserAct = createAction('removeUserEffect', props<{ id: number }>());
//export const removeSuccessUserAct = createAction('removeSuccessUserEffect', props<{ id: number }>());

export const setViolationsUserAct = createAction('setViolationsUserEffect', props<{ userForm: User, violations: {} }>());

export const showMsgErrorAct = createAction('showMsgErrorEffect', props<{ error: any }>() );


export const findAllRolesAct = createAction('findAllRolesEffect');
export const loadAllRolesAct = createAction('loadAllRolesEffect', props<{ roles: Role[] }>());